<template>
  <el-row v-if="extension" :gutter="20">
    <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
      插件名称：
      <el-link type="primary" :underline="false" style="margin-top: -5px; margin-right: 10px" href="javascript:;">
        {{ extension.displayName }}
      </el-link>
      插件Id：
      <el-link type="primary" :underline="false" style="margin-top: -5px; margin-right: 10px" href="javascript:;">
        {{ extension.userName }}.{{ extension.name }}
      </el-link>
      最新版本:
      <el-link type="primary" :underline="false" style="margin-top: -5px; margin-right: 10px" href="javascript:;">
        {{ extension.latestVersion }}
      </el-link>
    </el-col>
  </el-row>
  <div style="margin: 15px 30px 0">
    <template v-if="pageType === 'hosts'">
      <el-table :data="hosts" style="width: 100%" row-key="id">
        <el-table-column prop="siteName" label="网站云">
          <template #default="scope">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(scope.row) }}
            </el-link>
            <br v-if="scope.row.nickName" />
            <el-link :underline="false" @click.prevent>
              {{ scope.row.nickName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template #default="scope">
            <el-skeleton v-if="!!!scope.row.plugins" :rows="1" style="width: 100%" :loading="true" animated></el-skeleton>
            <el-button-group v-else>
              <el-button v-if="isInstall(scope.row)" type="primary" @click="btnDeployClick(scope.row, false)">部 署</el-button>
              <el-button v-else-if="isUpdate(scope.row)" type="primary" @click="btnDeployClick(scope.row, true)">升 级</el-button>
              <el-tag v-else type="primary">已部署</el-tag>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-else-if="pageType == 'success'">
      <div role="alert" class="el-alert el-alert--success is-light">
        <i class="el-alert__icon el-icon-success is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">插件部署成功</span>
          <p class="el-alert__description">
            恭喜，插件 {{ name }} 已成功部署至网站云 {{ getUniqueName() }}
            <el-divider></el-divider>
            <el-button type="primary" v-on:click="btnCloseClick">关 闭</el-button>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/my/plugins';
import utils from '@/utils';
import { IExtension, IHost } from '@/types/models';
import agentPlugins from '@/api/agent/plugins';

interface IState {
  pageType: string;
  hosts: IHost[];
  host: IHost;
  extension: IExtension;
}

export default defineComponent({
  name: 'Domains',
  emits: ['close'],
  props: {
    userName: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageType: 'hosts',
      hosts: [],
      host: {} as IHost,
      extension: {} as IExtension,
    } as IState;
  },
  methods: {
    apiGet() {
      this.pageType = 'hosts';
      this.hosts = [];
      this.host = {} as IHost;
      this.extension = {} as IExtension;

      api.getHosts({
        userName: this.userName,
        name: this.name,
      }, (res) => {
        if (!res) return;
        this.hosts = res.hosts;
        this.extension = res.extension;

        for (const host of this.hosts) {
          agentPlugins.getPlugins(
            host.hostName,
            host.nodeName,
            host.isHongKong,
            {
              securityKey: host.securityKey,
            },
            (res2) => {
              host.plugins = res2.plugins;
            },
          );
        }
      });
    },

    getUniqueName(host?: IHost) {
      return utils.getHostUniqueName(host || this.host);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    isInstall(host: IHost) {
      const plugin = host.plugins.find((x) => x.publisher === this.userName && x.name === this.name);
      if (!plugin) return true;
      return false;
    },

    isUpdate(host: IHost) {
      const plugin = host.plugins.find((x) => x.publisher === this.userName && x.name === this.name);
      if (!plugin) return false;
      if (plugin.version !== this.extension.latestVersion) return true;
      return false;
    },

    btnDeployClick(host: IHost, isUpdate: boolean) {
      this.host = host;
      const title = isUpdate ? '升级' : '部署';

      utils.alertDelete(
        {
          title: `${title}插件`,
          text: `此操作将插件 ${this.name} ${title}到网站云 ${utils.getHostUniqueName(this.host)}，确定吗？`,
          button: `确定${title}`,
        },
        () => {
          api.deploy(
            {
              userName: this.userName,
              name: this.name,
              hostId: host.id,
            },
            () => {
              this.pageType = 'success';
            },
          );
        },
      );
    },

    btnCloseClick() {
      this.$emit('close');
    },
  },
  watch: {
    userName: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
    name: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
